export const decidePageId = function (_lng){
    if( _lng === "en" ) return "2"
    else return "1";
}